/**
 * pdf 다운로드해서, base64로 반환하는 함수
 */
export async function urlToBase64(url) {
    return fetch(url).then((res) => {
        if (res.status !== 200) {
            let msg = '출력정보를 불러올 수 없습니다.';
            if (res.headers.has('gonelo-error-message-urlencoded')) {
                msg = decodeURI(res.headers.get('gonelo-error-message-urlencoded'));
            }
            throw new Error(msg);
        }

        return res.blob();

    }).then((blob) => {
        return new Promise((resolve, reject) => {
            var reader  = new FileReader();
            reader.addEventListener("load", function () {
                // 처음 파일정보부분 제거. e.g.  "data:image/png;base64,인코딩된데이터~~~"
                let base64 = reader.result.split(',')[1];
                resolve(base64);
            }, false);

            reader.onerror = () => {
                return reject(this);
            };
            reader.readAsDataURL(blob);
        });
    });
}